import { BaseError } from '@kiplin/web-common/error';

export class CurrentUserIsNotAClientError extends BaseError {
  public static readonly code = '7068e6f4-80b0-4cdd-9c17-0d6ccb1811c1';

  public constructor() {
    super(CurrentUserIsNotAClientError.code, 'Current user is not a client user');
  }
}
